<template>
	<div class="mshuiBrandCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst" src="../../assets/shuiBrand/shuiBigBd.jpg">
			<div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="enterProducts(4)">
					<img class="mFirstBoxImg" src="../../assets/shuiBrand/shuiyinyuan333.png" alt="">
				</div>
			</div>
		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="secondBox">
			<img class="mFirst" src="../../assets/mImg/mshuiP2.jpg" alt="">
		</div>



		<div class="thirdBox">
			<img class="mFirst5" src="../../assets/mImg/shuiZhongNewList.jpg" alt="">
			<!-- <img class="mDoubleThird" src="../../assets/shuiBrand/shuiBd4.png" alt=""> -->
			<div class="thirdBoxItem">

				<div class="thirdBoxItemRight">
					<div class="thirdBoxItemRightT1">品牌源起</div>
					<div class="thirdBoxItemRightT2">水是生命之本源，善利万物，于肌肤亦是如此。 “以水养肤，姻水结缘”，与爱美人士追求的纯 真爱情的精神内核相契合，水姻缘品牌由此而来。
					</div>
				</div>
			</div>
		</div>


		<div class="mForthItem">
			<div class="mForthItemMiddle">
				<div class="mForthItemMiddleLeft">
					<img class="linianImg" src="../../assets/shuiBrand/shuiBd5.png" alt="">
				</div>
				<div class="mForthItemMiddleRight">
					<div class="titleT">品牌理念</div>
					<div class="textT">遵循东方美的协调法则，溯源水的 至纯至净， 以水之精华润养肌肤， 调节水油平衡，激发肌肤本源之美， 悦享水润舒爽的护肤之旅。</div>
				</div>
			</div>
		</div>


		<div class="fifthBox">
			<div class="aboutTitle1">核心技术</div>
			<!-- <el-carousel class="carouselBoxMainLarge" :interval="3000" type="card"  indicator-position="none">
			    <el-carousel-item class="carouselBoxMain" v-for="(item,index) in technologyData" :key="index">
					<div class="carouselBox">
						<img class="carouselBoxItemImg" :src="item.img" alt="">
						<div class="carouselBoxMainMask">
							<div class="carouselBoxMainMaskTitle2">{{item.title}}</div>
						</div>
					</div>
			    </el-carousel-item>
			</el-carousel> -->
			<wc-swiper class="swiperItemBox">
				<wc-slide v-for="(item,index) in technologyData" :key="index">
					<div class="swiperBoxMain">
						<img class="swiperBoxMainImg" :src="item.img" alt="">
						<div class="swiperBoxMainTitle2">{{item.title}}</div>
					</div>
				</wc-slide>
			</wc-swiper>
		</div>


		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			technologyData: [
				{
					id: 1,
					img: require('../../assets/shuiBrand/syyBottomNew1.png'),
					title: '以水养肤，姻水结缘'
				},
				{
					id: 2,
					img: require('../../assets/shuiBrand/syyBottomNew2.png'),
					title: '绿色草本注能，生命能量护肤'
				},
				{
					id: 3,
					img: require('../../assets/shuiBrand/shuiBrandItem3.png'),
					title: '修护、保养、预防三效合一'
				}
			],
			drawer: false,
			direction: 'ltr'
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		enterProducts(id) {
			this.$router.push({ path: '/mProductList', query: { brandId: id } });
		}
	},


}
</script>

<style scoped>
.mshuiBrandCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBoxMenu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.mFirstBoxImgMenu {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.mFirstBox {
	position: absolute;
	top: 20%;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
}

.mFirstBoxImg {
	width: 45%;
	float: left;
	margin-left: 5%;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}


.secondBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.thirdBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	position: relative;
	top: 0;
	/* align-items: center; */
	/* background: url(../../assets/mImg/shuiZhongNewList.jpg) no-repeat;
		background-size: 100%;
		padding-top:20%;
		padding-bottom:25%; */
}



.mDoubleThird {
	width: 85%;
	margin: 0 auto;
	position: absolute;

}


.fifthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.thirdBoxItem {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	/* margin-top: -14rem; */
	position: absolute;
	top: 28%;
}


.thirdBoxItemRight {
	/* display: flex;
		flex-direction: column; */
	width: 50%;
	margin-right: 5%;
	position: absolute;
}

.thirdBoxItemRightT1 {
	color: #222222;
	font-size: 1.2rem;
	font-weight: bold;
}

.thirdBoxItemRightT2 {
	color: #222222;
	font-size: 0.9rem;
}



.mForthItem {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #7F2620;
}

.mForthItemMiddle {
	width: 90%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 15%;
	margin-bottom: 15%;
}

.mForthItemMiddleLeft {
	width: 48%;
}

.linianImg {
	width: 100%;
}

.mForthItemMiddleRight {
	width: 50%;
	display: flex;
	flex-direction: column;
	margin-left: 0.5rem;
}

.titleT {
	color: #FFFFFF;
	font-size: 1.2rem;
}

.textT {
	color: #FFFFFF;
	font-size: 0.9rem;
	opacity: 0.8;
	margin-top: 0.3rem;
}



.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #FFFFFF;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.carouselBoxMain {
	width: 50%;
	margin: 0 auto;
}



.carouselBoxMainMaskTitle1 {
	color: #222222;
	line-height: 1.875rem;
	font-size: 1.25rem;
}

.carouselBoxMainMaskTitle2 {
	color: #888888;
	font-size: 0.875rem;
	text-align: center;
	margin-top: 1rem;
}

.carouselBoxItemImg {
	width: 100%;
}

.carouselBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.carouselBoxmain2 {
	width: 100%;
	display: flex;
	margin-top: -14rem;
	padding-bottom: 1rem;
}

.aboutTitle1 {
	font-size: 1.2rem;
	color: #000000;
	font-weight: bold;
	margin-top: 1rem;
	line-height: 50px;
}

.carouselBoxMainLarge {
	width: 90%;
	margin: 0 auto;
	margin-top: 1rem;
}

.carouselBoxMainMask {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #FFFFFF;
	z-index: 999;
}

.carouselBoxMainMaskTitle1 {
	color: #222222;
	line-height: 1.875rem;
	font-size: 1.25rem;
}

.carouselBoxMainMaskTitle2 {
	color: #888888;
	font-size: 0.875rem;
	line-height: 1.875rem;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color: #7F2620;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}


.mFirst5 {
	width: 100%;
	position: relative;
}

.swiperBoxMain {
	width: 80%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 8%;
}

.swiperBoxMainImg {
	width: 100%;
	border-radius: 1rem;
}

.swiperBoxMainTitle2 {
	color: #666666;
	font-size: 1.1rem;
	margin-top: 1rem;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mshuiBrand.vue